import * as React from 'react';
import { useCallback } from 'react';

import { compose } from 'recompose';

import connectToStores from 'js/lib/connectToStores';

import { withTheme } from '@coursera/cds-core';

import usePathname from 'bundles/authentication/shared/hooks/usePathname';
import type { ExecuteAction } from 'bundles/author-s12n/components/types';
import withFluxibleContextAsProps from 'bundles/author-s12n/utils/withFluxibleContextAsProps';
import localStorageEx from 'bundles/common/utils/localStorageEx';
import ProgramQualificationActions from 'bundles/university-program-qualification/actions/ProgramQualificationActions';
import ProgramQualificationStore from 'bundles/university-program-qualification/store/ProgramQualificationStore';
import type { Props as EmbeddedRegFormProps } from 'bundles/xddp/components/expression-of-interest/EmbeddedRegForm';
import EmbeddedRegForm from 'bundles/xddp/components/expression-of-interest/EmbeddedRegForm';
import { LOCAL_STORAGE_EOI_EMBEDDED_SIGN_IN_DATA } from 'bundles/xddp/constants';

type PropsFromFluxible = {
  executeAction: ExecuteAction<$TSFixMe>;
  response: {};
  validationErrors: $TSFixMe;
};

type Props = PropsFromFluxible & EmbeddedRegFormProps & { degreeId: string };

export function DLPEmbeddedRegFormContainer({
  executeAction,
  response: eoiResponseProp,
  validationErrors,
  degreeId,
  ...rest
}: Props): React.ReactElement {
  const pathname = usePathname();

  const onFormToggled = useCallback(() => {
    executeAction(ProgramQualificationActions.resetResponse);
  }, [executeAction]);

  const onRegSuccess = useCallback(() => {
    // Set data to local storage to measure complete EOI flow
    localStorageEx.setItem(
      LOCAL_STORAGE_EOI_EMBEDDED_SIGN_IN_DATA,
      { ts: Date.now(), degreeId, pathname, slug: rest?.slug },
      JSON.stringify
    );
  }, [pathname, degreeId, rest?.slug]);

  return (
    <EmbeddedRegForm
      {...rest}
      onRegSuccess={onRegSuccess}
      formToggled={onFormToggled}
      trackingProductId={degreeId.replace('base~', '')}
    />
  );
}

export default compose<Props, EmbeddedRegFormProps & { degreeId: string }>(
  connectToStores<Props, PropsFromFluxible>([ProgramQualificationStore], (storeInstance, props) => ({
    ...props,
    response: storeInstance.getResponse(),
    validationErrors: storeInstance.getResponseValidation(),
  })),
  withFluxibleContextAsProps<Props, PropsFromFluxible, $TSFixMe>(),
  withTheme
)(DLPEmbeddedRegFormContainer);
